import React, { Component } from "react";
import { Select } from "antd";
import { DatePicker, Input } from "antd";
import { Button, Form, Label, Row, Col } from "reactstrap";
import "../../styles/features/DocumentsFilters/Filters.css";

const Option = Select.Option;

class Filters extends Component {
  componentWillMount = () => {};
  state = {};
  returnForm = formObj => {
    switch (formObj.type) {
      case "select":
        return (
          <>
            <Col
              xs="4"
              style={{
                padding: 0,
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Label
                style={{ margin: "0px 5px", fontSize: "15px" }}
                for="selecttest"
              >
                {formObj.name}
              </Label>
            </Col>
            <Col xs="8">
              <Select
                name="selecttest"
                value={this.state[formObj.name]}
                placeholder={formObj.name}
                defaultValue=""
                style={{ width: 200 }}
                onChange={e => {
                  let state = this.state;
                  state[formObj.name] = e;
                  this.setState(state);
                  this.props.changeFilter("select", formObj, e);
                }}
              >
                {formObj.values.map(value => {
                  return <Option value={value.id}>{value.emri}</Option>;
                })}
              </Select>
            </Col>
          </>
        );

      case "text":
        return (
          <>
            <Col
              xs="4"
              style={{
                padding: 0,
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Label
                style={{ margin: "0px 5px", fontSize: "15px" }}
                for="selecttest"
              >
                {formObj.name}
              </Label>
            </Col>
            <Col xs="8">
              <Input
                placeholder={formObj.name}
                allowClear
                onChange={e => {
                  console.log(e.target.value);
                  this.props.changeFilter("text", formObj, e.target.value);
                }}
                style={{ width: 200 }}
              />
            </Col>
          </>
        );

      case "Date":
        return (
          <>
            <Col
              xs="4"
              style={{
                padding: 0,
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Label
                style={{ margin: "0px 5px", fontSize: "15px" }}
                for="selecttest"
              >
                {formObj.name}
              </Label>
            </Col>
            <Col xs="8">
              <DatePicker
                placeholder={""}
                style={{ width: 200 }}
                onChange={() => {}}
              />
            </Col>
          </>
        );
      default:
        return null;
    }
  };
  render() {
    return (
      <div style={{ margin: "30px" }}>
        <Form>
          <Row style={{ display: "flex" }}>
            {this.props.data.filters.map(filterObj => {
              return (
                <Col
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px 0px"
                  }}
                  lg="4"
                  md="6"
                  sm="6"
                  xs="12"
                >
                  {this.returnForm(filterObj)}
                </Col>
              );
            })}
          </Row>
        </Form>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
          className="filter"
        >
          <div style={{ paddingRight: "34px" }}>
            <Button
              outline
              color="primary"
              onClick={() => {
                let state = this.state;
                for (var key in state) {
                  if (state.hasOwnProperty(key)) {
                    state[key] = undefined;
                  }
                }
                this.setState(state);
                this.props.pastro();
              }}
              className="filter_btn"
            >
              Pastro filtrat
            </Button>{" "}
          </div>
          <div>
            <Button
              outline
              onClick={() => {
                this.props.kerko();
              }}
              color="primary"
            >
              Kerko
            </Button>{" "}
          </div>
        </div>
      </div>
    );
  }
}

export default Filters;
